import { useTranslation } from '@/contexts/LanguageContext';
import SEO from '@/components/SEO';

export default function TermsPage() {
  const { t } = useTranslation('terms');

  const sections = t('sections');
  const sectionsList = Array.isArray(sections) ? sections : [];

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="terms-page">
      <SEO title="Conditions d'utilisation" description="Consultez les conditions générales d'utilisation de la marketplace B2B de déstockage professionnel DestockPro." path="/conditions-utilisation" />
      <section className="mb-10">
        <h1 className="font-heading text-3xl font-bold text-neutral-900 dark:text-white mb-2">{t('title')}</h1>
        <p className="text-sm text-neutral-400 dark:text-neutral-500">{t('lastUpdate')}</p>
      </section>

      <section className="space-y-8" data-testid="terms-content">
        {sectionsList.map((section, i) => (
          <div key={i}>
            <h2 className="font-heading text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">{section.title}</h2>
            <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-relaxed">{section.text}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
